<template>
  <ConfigurationProcessTemplate
    :endPointData="endPointData"
    :textData="textData"
  />
</template>
<script setup>
import { computed } from 'vue';

// Utils
import { useRoute } from 'vue-router';
import generateTextData from '@/functions/generate_text_data';

// Components
import ConfigurationProcessTemplate from '@/components/generic/configuration_process_template.vue';

const route = useRoute();

const endPointData = {
  newFormRoute: 'newEquipmentProcessForm',
  operationType: 'process',
  endpointIdentifier: 'equipment_processes',
  processGroupsEndpoint: `/organisations/${route.params.organisationId}/equipment_processes`,
  nav: 'configuration.process.nav.equipment',
};

const mainKey = 'configuration.process';
const textDataArray = [
  'search',
  'new',
];

const textData = computed(() => {
  return generateTextData(mainKey, textDataArray);
});
</script>
